module.exports = __webpack_public_path__ + "img/cloud_upload.d9d1148b.svg";